import { Injectable } from '@angular/core';
import { CompaniesApiService, VehicleDto } from '@fleet-beat/api';
import {
  BaseDataSourceServiceV2,
  CompanyDto,
  GetManyV2Dto,
  PageableListV2Dto,
  SnackbarService,
} from '@fleet-beat/core';
import { DataAutocompleteStorageParams } from '@fleet-beat/editor';
import { AuthService } from '@fleet-beat/shared';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CompanyListAdminAutocompleteStorageService extends BaseDataSourceServiceV2<
  CompanyDto,
  DataAutocompleteStorageParams<object>
> {
  constructor(
    protected override snackbarService: SnackbarService,
    private authService: AuthService,
    private companiesApiService: CompaniesApiService,
  ) {
    super(snackbarService);
  }

  protected override getData(
    data: DataAutocompleteStorageParams<{ input: string; include?: string }>,
  ): Observable<PageableListV2Dto<VehicleDto>> {
    const params: GetManyV2Dto = {
      ...data.params,
      ...data.extra,
      search: data.params.input,
    };
    return this.companiesApiService.getManyAsAdmin(params, this.authService.authHeaders);
  }

  /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
  protected override getById(id: string): Observable<CompanyDto> {
    throw new Error('Not Implemented');
  }
}
